import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_ASSOCIATION } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetOwnerMasterListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnerMasterList = async (data: any) =>
  await axiosAuth.post(`${PROPERTY_ASSOCIATION}/owners/grid`, data);

const useGetOwnerMasterList = ({
  data,
  queryParams,
}: UseGetOwnerMasterListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-master"],
    queryFn: () => getOwnerMasterList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetOwnerMasterList;
